import {
  setLoggedInVendorDetails,
  setSelectedAccount,
} from '../../common/helper'
import { isLoggedInAsInternalUser } from '../../common/userAccessHelpers'
import useUserType from '../../domain/useUserType'
import apiConfig from '../../config/apiConfig'
import { useQueryClient } from '@tanstack/react-query'
import { GET_TEMPLATES_KEY } from '../../constants'
interface Props {
  vendorOptions: any
  currentAccount: any
  setSwitchAccountVisible: (visible: boolean) => void
}
const LoggedInVendorDetails = (props: Props) => {
  const { data: userDetails } = useUserType()
  const { user_type } = userDetails || {}
  const carId = apiConfig?.crossAdvertiser?.carId
  const queryClient = useQueryClient()

  const isExternalUser = () => {
    return ['EXTERNAL_OTHERS', 'EXTERNAL_RMS', 'EXTERNAL_TARGET_PLUS'].includes(
      user_type,
    )
  }

  const { vendorOptions, setSwitchAccountVisible, currentAccount } = props
  if (
    vendorOptions?.length &&
    !isLoggedInAsInternalUser() &&
    isExternalUser()
  ) {
    setLoggedInVendorDetails(vendorOptions[0])
  } else if (
    vendorOptions?.length &&
    isLoggedInAsInternalUser() &&
    !currentAccount
  ) {
    const selectedAccount = vendorOptions.find(
      (vendor: SelectOption) => vendor.id === carId,
    )
    setSelectedAccount(selectedAccount)
    setSwitchAccountVisible(false)
    const pathUrl = window.location.href
    if (pathUrl.includes('/view?t=') || pathUrl.includes('/view/')) {
      queryClient.invalidateQueries({
        queryKey: [GET_TEMPLATES_KEY],
      })
      window.location.href = '/'
    } else {
      window.location.reload()
    }
  }
  return <></>
}

export default LoggedInVendorDetails
